import React, { useState, useEffect } from 'react';
import '../style/Home.css';
import { Container, Table } from "react-bootstrap";
import { Button, Toast, } from 'react-bootstrap';
import Form from "react-bootstrap/Form";
import { Row, Col } from 'react-bootstrap';
import { apiFetchJson } from '../api';


// TODO: maybe search feature. 


const Info = ({ dbName }) => {
    const [dbData, setDBData] = useState([]);
    const [status, setStatus] = useState('--');
    const [message, setMessage] = useState('');

    function refresh() {
        apiFetchJson('/api/info/' + dbName)
            .then((data) => {
                const rows = Array.isArray(data?.db) ? data.db : [];
                setDBData(rows);
                setStatus(data?.status ?? 'FAIL');
                setMessage(data?.message ?? '');
            })
            .catch((err) => {
                setDBData([]);
                setStatus('FAIL');
                // Flask-JWT-Extended commonly returns {"msg": "..."} on 401
                const msg =
                    (err?.body && (err.body.message || err.body.msg)) ||
                    err?.message ||
                    'Request failed';
                setMessage(msg);
            });
    }


    useEffect(() => {
        refresh();
    }, []);


    function doDelete(id) {
        apiFetchJson('/api/delete/' + dbName + '/' + id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((data) => {
                const rows = Array.isArray(data?.db) ? data.db : [];
                setDBData(rows);
                setStatus(data?.status ?? 'SUCCESS');
                setMessage(data?.message ?? '');
            })
            .catch((err) => {
                setStatus('FAIL');
                const msg =
                    (err?.body && (err.body.message || err.body.msg)) ||
                    err?.message ||
                    'Delete failed';
                setMessage(msg);
            });
    }

    const loadResults = (traineeID, simulationID) => {
        let input = document.getElementById('Upload'+simulationID);
        const body = new FormData();
        body.append('file', input.files[0]);

        apiFetchJson('/api/upload/trainee/' + traineeID + '/' + simulationID + '/ZIP', {
            method: 'POST',
            body: body,
        })
            .then(data => {
                console.log('Return from zip submit', data);
                setStatus(data.status);
                setMessage(data.message);
            })
            .catch(error => {
                console.log(error);
                setStatus('FAIL');
                setMessage('FAIL- Please try again later or contact support');
            })

    };


    return (
        <Container>
            <div className="row">
                <div className='col-lg-9'>
                    <h1>Summary of {dbName} database</h1>
                </div>
                <div className='col-lg-3'>
                    <Button className='my-3' onClick={refresh}>Refresh</Button>
                </div>
            </div>
            <Toast className='mb-4'>
                <Toast.Header closeButton={false}>
                    <strong className="me-auto">STATUS: {status}</strong>
                </Toast.Header>
                <Toast.Body>{message}</Toast.Body>
            </Toast>

            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Studies</th>
                        <th>Date added</th>
                        <th>Load Results</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {dbData.map((entry) => (
                        <tr key={entry.id}>
                            <td>{entry.name}</td>
                            <td>{entry.email}</td>
                            <td>
                                {entry.studies && entry.studies.length > 0 && entry.studies.map((iStudy) => (
                                    <Row key={'study'+iStudy.studyID}>
                                        <p>{iStudy.studyName}</p>
                                    </Row>
                                ))
                                }
                            </td>
                            <td>{entry.dateAdded}</td>
                            <td>
                                {entry.simulations && entry.simulations.length > 0 && entry.simulations.map((iSimulation) => (
                                    <Row key={'d'+iSimulation.id}>
                                        <Col>
                                        <Form.Control type="file" key={'f'+iSimulation.id} id={"Upload"+iSimulation.id} name="upload"/>
                                        </Col>
                                        <Col>
                                        <Button key={iSimulation.id} size='sm' className="ml-1" onClick={() => loadResults(entry.id, iSimulation.id)}>Load: {iSimulation.id} {iSimulation.simulationID}</Button> 
                                        </Col>
                                    </Row>
                                ))
                                }
                            </td>
                            <td>
                                <Button size='sm' onClick={() => doDelete(entry.id)}>Delete</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

        </Container>
    );
}

export default Info;
